import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BANK_MAIL_DETAILS_API } from '../../constants/bank-mail-details-api';
import { HttpClientService } from '../httpClient/httpClient.service';

@Injectable({
  providedIn: 'root',
})
export class BankMailDetailsService {
  constructor(private httpClientService: HttpClientService) {}

  getAllBankDetails(filters?: any, skip: number = 0, limit: number = 10): Observable<any> {
    let query = `?`;
    if (filters) {
        if (filters.bankName) {
            query += `bankName=${filters.bankName}&`;
        }
        if (filters.domainName) {
            query += `domainName=${filters.domainName}&`;
        }
        if (filters.hoEmailId) {
            query += `hoEmailId=${filters.hoEmailId}&`;
        }
        if (filters.status !== undefined && filters.status !== null) {
            query += `status=${filters.status}&`;
        }
    }
    query += `skip=${skip}&limit=${limit}`;
    return this.httpClientService.get(`${BANK_MAIL_DETAILS_API.GET_ALL}${query}`);
}
  getBankNames(): Observable<any> {
    return this.httpClientService.get(
      `${BANK_MAIL_DETAILS_API.GET_BANK_NAMES}`
    );
  }

  addBankDetails(bankDetails: any): Observable<any> {
    return this.httpClientService.post(BANK_MAIL_DETAILS_API.ADD, bankDetails);
  }

  updateBankDetails(bankDetailsId: string, bankDetails: any): Observable<any> {
    return this.httpClientService.put(
      `${BANK_MAIL_DETAILS_API.UPDATE}?bankDetailsId=${bankDetailsId}`,
      bankDetails
    );
  }

  changeStatus(bankDetailsId: string): Observable<any> {
    return this.httpClientService.put(
      `${BANK_MAIL_DETAILS_API.CHANGE_STATUS}?bankDetailsId=${bankDetailsId}`,
      {}
    );
  }

  getBankDetailsById(bankDetailsId: string): Observable<any> {
    return this.httpClientService.get(
      `${BANK_MAIL_DETAILS_API.GET_BY_ID}/${bankDetailsId}`
    );
  }

  getQueryField(queryField: string): Observable<any> {
    return this.httpClientService.get(
      `${BANK_MAIL_DETAILS_API.GET_QUERY_FIELD}/${queryField}`
    );
  }
  getBankDetailsInMail(stuCountryId: string): Observable<any> {
    return this.httpClientService.get(`${BANK_MAIL_DETAILS_API.GET_BANK_OPTIONS_MAIL}${stuCountryId}`);
  }

  getZonalOffices(bankName: string): Observable<any> {
    return this.httpClientService.get(`${BANK_MAIL_DETAILS_API.GET_BANK_BY_NAME}${bankName}`);
}
getBankOtherDetails(bankName: string, zonalOffice: string): Observable<any> {
    return this.httpClientService.get(
        `${BANK_MAIL_DETAILS_API.GET_BANK_OTHER_DETAILS}${bankName}&zonalOffice=${zonalOffice}`
    );
}
}